import React, { useState } from 'react';
import Calendar from '@/components/custom/legacy-calendar';
import ViewTask from './ViewTask';
import Onboarding from '@/components/custom/onboarding';
import { useSession } from '@/hooks/useSession';
import { useTranslation } from 'react-i18next';
import { DashboardContent } from '@/layouts/dashboard';

function MyTasks(props) {
  const { t } = useTranslation();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const path = props.path;
  const { session } = useSession();
  const profiles = session?.user?.profileNames || (session?.user && session?.user['profile-names']) || [];

  return (
    <DashboardContent>
      <div className="home-content">
        <Calendar.Expanded
          myTasks
          slotType="master_slot"
        />
      </div>

      <Onboarding
        path={path}
        show={showOnboarding}
        setShowOnboarding={setShowOnboarding}
        onClose={() => setShowOnboarding(false)}
        profiles={profiles}
        title={t('onboarding.titleTasks')}
        videoId="_xkxl1uzQSI"
      />
    </DashboardContent>
  );
}

export { MyTasks, ViewTask };
